module.exports = __webpack_public_path__ + "img/ads_nophoto_truck.1bb0d269.png";